import { render, staticRenderFns } from "./Kills.vue?vue&type=template&id=72646677&"
import script from "./Kills.vue?vue&type=script&lang=js&"
export * from "./Kills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports